import { Form, Input, Modal, Select, Button } from "antd";

const App = ({ isFilterModalOpen, setIsFilterModalOpen, handleFilter }) => {
  return (
    <>
      <Modal
        title="Filter Properties"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isFilterModalOpen}
        onCancel={() => setIsFilterModalOpen(false)}
        footer={false}
      >
        <Form
          // form={form}
          layout="vertical"
          className="Crm-modal-container"
          onFinish={handleFilter}
        >
          <Form.Item
            name="ufCrm18ReferenceNumber"
            label="Reference Number"
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="ufCrm18TitleEn"
            label="Title"
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="ufCrm18Price"
            label="Price"
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="ufCrm18Status"
            label="Status"
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Select
              options={[
                { value: "PUBLISHED", label: "Published" },
                { value: "DRAFT", label: "Draft" },
                { value: "UNPUBLISHED", label: "Unpublished" },
                { value: "LIVE", label: "Live" },
                { value: "ARCHIVED", label: "Archived" },
                { value: "POCKET", label: "Pocket" },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="ufCrm18OfferingType"
            label="Offering Type "
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Select
              options={[
                { value: "none", label: "None" },
                { value: "commercial", label: "Commercial" },
                { value: "residential", label: "Residential" },
              ]}
              placeholder=""
            />
          </Form.Item>
          <Form.Item
            name="ufCrm18PropertyType"
            label="Property Type "
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Select
              options={[
                { value: "", label: "Please select" },
                { value: "apartment", label: "Apartment" },
                { value: "bulk-rent-unit", label: "Bulk Rent Unit" },
                { value: "bulk-sale-unit", label: "Bulk Sale Unit" },
                { value: "bungalow", label: "Bungalow" },
                { value: "compound", label: "Compound" },
                { value: "duplex", label: "Duplex" },
                { value: "full-floor", label: "Full Floor" },
                { value: "half-floor", label: "Half Floor" },
                { value: "hotel-apartment", label: "Hotel Apartment" },
                { value: "land", label: "Land" },
                { value: "penthouse", label: "Penthouse" },
                { value: "townhouse", label: "Townhouse" },
                { value: "villa", label: "Villa" },
                { value: "whole-building", label: "Whole Building" },
                { value: "bulk-rent-unit", label: "Bulk Rent Unit" },
                { value: "bulk-sale-unit", label: "Bulk Sale Unit" },
                { value: "business-center", label: "Business Center" },
                { value: "co-working-space", label: "Co Working Space" },
                { value: "factory", label: "Factory" },
                { value: "farm", label: "Farm" },
                { value: "full-floor", label: "Full Floor" },
                { value: "half-floor", label: "Half Floor" },
                { value: "labor-camp", label: "Labor Camp" },
                { value: "land", label: "Land" },
                { value: "office-space", label: "Office Space" },
                { value: "retail", label: "Retail" },
                { value: "shop", label: "Shop" },
                { value: "show-room", label: "Show Room" },
                { value: "staff-accommodation", label: "Staff Accommodation" },
                { value: "villa", label: "Villa" },
                { value: "warehouse", label: "Warehouse" },
                { value: "whole-building", label: "Whole Building" },
              ]}
            />
          </Form.Item>
          {/* Footer Buttons */}
          <Form.Item>
            <div className="form_submit pt-15">
              <Button
                className="back_button"
                onClick={() => setIsFilterModalOpen(false)}
              >
                Cancel
              </Button>

              <Button htmlType="submit" type="primary">
                Find
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default App;
